import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ContactUserDetailsViewModel } from '../../../business-entities/contact-user-details-view-model';
import { ContactUserService } from '../../../business-services/contact-user-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PagerData } from '../../../business-entities/PagerData';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { Filter } from '../../../business-entities/Filter';
import { PaginationService } from '../../../services/pagination.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contact-user',
  templateUrl: './contact-user.component.html'
})
export class ContactUserComponent implements OnInit {
  searchTerm: string;
  contactUserList:ContactUserDetailsViewModel[];
  contactUserExcelList:ContactUserDetailsViewModel[]=[];
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25//Constant.GridPagerSize
  }
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  throttle = 100;
  scrollDistance = 1;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private contactUserService:ContactUserService,
    private spinner: NgxSpinnerService,
    private pagerService: PaginationService,
    private excelService: ExcelService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private toaster: ToastrService,
  ) { }
  ngOnInit(): void {
    this.contactUserService.contactUserListRequest.startRecordNumber = 0;
    this.contactUserList = []
    this.getContactUserList();
  }

  onSearchFilter() {
    this.contactUserService.contactUserListRequest.startRecordNumber = 0;
    this.contactUserService.contactUserListRequest.searchTerm = this.searchTerm;
    this.contactUserList = []
    this.getContactUserList();
  }

  async getContactUserList() {
    this.spinner.show();
    try{
      await this.contactUserService.getContactUserList(this.contactUserService.contactUserListRequest).then((response) => {
        this.spinner.hide();
        this.contactUserList.push(...this.contactUserDataMapper(response.responseObject.contactUserList));
        if (response.responseObject?.result?.errorCode == "5449") {
          this.totalCount = 0;
        }
        else {
          this.totalCount = this.contactUserList.length > 0 ? this.contactUserList[0].totalCount : 0;
        }
        this.resetPagerData(this.supplierInitiliseGridFromServer(this.contactUserList, this.totalCount));
        if (this.pagerData.page > 1) {
          this.resetPagerData(this.initilisePagerFromServer(this.pagerData.page, this.pagerData.pagerSize, this.totalCount));
        }

      },_error => {
        this.spinner.hide()
      });
  }
  catch{
    this.spinner.hide();
  }
  }

  async getContactUserListForDocument(type) {
    this.contactUserService.contactUserListRequest.isForDocuments = true;
    this.spinner.show();
    try{
      await this.contactUserService.getContactUserList(this.contactUserService.contactUserListRequest).then((response) => {
        this.spinner.hide();
        this.contactUserExcelList = this.ExcelDataMapper(response.responseObject.contactUserList);
        if (this.contactUserExcelList.length === 0) {
          this.toaster.error(this.translate.instant('lblDataNotAvailable'));
          return ;
        }
        if(type === Enums.DocumentsType.Pdf)
        {
          this.cdr.detectChanges();
          if (this.contactUserExcelList && this.contactUserExcelList.length > 0) {
            this.spinner.show();
            this.cdr.detectChanges();
            const doc = new jsPDF();
            autoTable(doc, { html: '#PDFdata', margin: { top: 3, left: 3, right: 3, bottom: 3 }, styles: { fontSize: 8 }, columnStyles: {
               0: { cellWidth: 9 }, 
               1: { cellWidth: 25 }, 
               2: { cellWidth: 40 }, 
               3: { cellWidth: 40 } ,
               4: { cellWidth: 40 }, 
               5: { cellWidth: 50 } ,
              }
            });
            doc.save(`${this.translate.instant('lblContactUsers')}.pdf`);
            this.spinner.hide();
          }
        }
        if(type === Enums.DocumentsType.Excel)
        {
          this.excelService.exportAsExcelFile(this.contactUserExcelList, `${this.translate.instant('lblContactUsers')}`);
        }
      },_error => {
        this.spinner.hide()
      });
      this.contactUserService.contactUserListRequest.isForDocuments = false;
  }
  catch{
    this.spinner.hide();
  }
  }
  private ExcelDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.No = index + 1;
        single.WoNo = element.woNumber;
        single.CustomerName = element.customerName;
        single.MobilNo = element.mobileNo ? +element.mobileCode + ' ' + element.mobileNo : '';
        single.Email = element.email;
        single.Address = element.addressLine1 ? element.addressLine1 : '' + ' ' +  element.pincode  + ' ' + element.city  + ' ' + element.country ;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }
  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  public async exportAsXLSX(_excel: number) {
    this.getContactUserListForDocument(_excel);
  }
  public async onDownloadPDF(_pdf: number) {
    this.cdr.detectChanges();
    this.getContactUserListForDocument(_pdf);

    
  }
  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = (data.length === 0) ? 0 : 1;
    return this.initilisePagerFromServer(this.filter.page, Number(this.filter.pageSize), count);
  }

  initilisePagerFromServer(page: number, _pageSize: number, count: number = this.filterItems.length) {
    let length = this.filterItems.length <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems; // .slice(this.pager.startIndex, this.pager.endIndex + 1);
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  private contactUserDataMapper(contactUser: any) {
    let supperArray = [];
    if (contactUser && contactUser.length > 0) {

      for (let index = 0; index < contactUser.length; index++) {
        const element = contactUser[index];

        let single = Object();
        single.rowNumber = (this.contactUserService.contactUserListRequest.startRecordNumber + 1) + index;
        single.id = element.id
        single.woNumber = element.woNumber
        single.customerName = element.customerName
        single.mobileNo = element.mobileNo
        single.mobileCode = element.mobileCode;
        single.email = element.email
        single.addressLine1 = element.addressLine1
        single.pincode = element.pincode
        single.city = element.city
        single.country = element.country
        single.totalCount = element.totalCount
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.contactUserService.contactUserListRequest.sortColumn = column;
    this.contactUserService.contactUserListRequest.sortDirection = direction;
    this.onRefresh();
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.contactUserList.length){
      this.contactUserService.contactUserListRequest.startRecordNumber = this.contactUserList.length;
      this.getContactUserList();
    }
  }

  onRefresh() {
   this.ngOnInit()
  }
}
